import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as ScrollLink } from 'react-scroll';
// logo
import newLogo from '../assets/img/Przezroczysty.png';
import newkolor from '../assets/img/Przezroczysty_kolor.png';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [header, setHeader] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setHeader(window.scrollY > 50);
    });
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header
      className={`${
        header ? 'bg-white py-2 shadow-lg' : 'bg-transparent py-8'
      } fixed z-50 w-full transition-all duration-500`}
    >
      <div className='container mx-auto flex flex-col items-center gap-y-6 lg:flex-row lg:justify-between lg:gap-y-0'>
        <a href='/'>
          {header ? (
            <img className='w-[100px]' src={newLogo} />
          ) : (
            <img className='w-[100px]' src={newkolor} />
          )}
        </a>
        <nav
          className={`${
            header ? 'text-primary' : 'text-white'
          } flex gap-x-4 font-tertiary tracking-[2px] text-[15px] items-center uppercase lg:gap-x-8 flex-wrap`}
        >
          {/* <ScrollLink
            to='hotel'
            smooth={true}
            duration={500}
            className='hover:text-accent transition cursor-pointer'
          >
            {t('Hotel')}
          </ScrollLink> */}
          <ScrollLink
            to='rooms'
            smooth={true}
            duration={500}
            className='hover:text-accent transition cursor-pointer'
          >
            {t('Pokoje')}
          </ScrollLink>
          <ScrollLink
            to='packages'
            smooth={true}
            duration={500}
            className='hover:text-accent transition cursor-pointer'
          >
            {t('Pakiety')}
          </ScrollLink>
          <ScrollLink
            to='okolica'
            smooth={true}
            duration={500}
            className='hover:text-accent transition cursor-pointer'
          >
            {t('Okolica')}
          </ScrollLink>
          <ScrollLink
          to='galeria'
          smooth={true}
          duration={500}
          className='hover:text-accent transition cursor-pointer'
          >
            {t('galeria')}
          </ScrollLink>
          <ScrollLink
            to='contact'
            smooth={true}
            duration={500}
            className='hover:text-accent transition cursor-pointer'
          >
            {t('Kontakt')}
          </ScrollLink>
          
        </nav>
      </div>
      <div className='fixed right-5 top-6 text-2xl'>
        <button className='bg-white px-1 rounded-lg' onClick={() => changeLanguage('pl')}>🇵🇱</button>
        <button className='mx-1 bg-white rounded-lg px-1' onClick={() => changeLanguage('en')}>🇬🇧</button>
        <button className='bg-white px-1 rounded-lg' onClick={() => changeLanguage('de')}>🇩🇪</button>
      </div>
    </header>
  );
};

export default Header;
